// OR color swatch: comma path = union (page 1 per tag, parallel)
(function () {
  if (window.__ccfsOrOnly) return;
  window.__ccfsOrOnly = true;

  var loadGen = 0;

  function hz(t) {
    return String(t == null ? '' : t).toLowerCase().trim()
      .replace(/[^\w\u00a1-\uffff]+/g, '-').replace(/-+/g, '-').replace(/^-|-$/g, '');
  }

  function basePath() {
    var h = document.querySelector('[data-collection-handle]');
    var handle = h && h.getAttribute('data-collection-handle');
    var p = location.pathname.split('?')[0].replace(/\/+$/, '');
    if (handle) {
      var m = p.match(new RegExp('^(.*/collections/' + handle.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + ')(?:/.+)?$'));
      if (m) return m[1];
    }
    return p;
  }

  function sectionId() {
    var g = document.getElementById('main-collection-product-grid');
    return g && g.dataset.id;
  }

  function parseBtn(btn) {
    try {
      var a = JSON.parse(btn.getAttribute('data-filter-values') || '[]');
      return Array.isArray(a) ? a.map(String).filter(Boolean) : [];
    } catch (_) { return []; }
  }

  function parsePath() {
    var pre = basePath() + '/';
    var tail = location.pathname.split('?')[0].replace(/\/+$/, '');
    if (tail.indexOf(pre) !== 0) return null;
    tail = tail.slice(pre.length);
    if (!tail || tail.indexOf(',') < 0 || tail.indexOf('/') >= 0) return null;
    var tags = tail.split(',').map(function (s) {
      try { return decodeURIComponent(s.trim()); } catch (_) { return s.trim(); }
    }).filter(Boolean);
    return tags.length > 1 ? tags : null;
  }

  function orPath(tags) {
    return basePath() + '/' + tags.map(function (t) { return encodeURIComponent(t.trim()); }).join(',');
  }

  function orKey(tags) {
    return tags.map(hz).filter(Boolean).sort().join(',');
  }

  function itemsFrom(html) {
    var out = [];
    if (!html) return out;
    try {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      doc.querySelectorAll('.product-loop__item').forEach(function (el) {
        var n = el.querySelector('[data-product-handle]');
        var h = n && n.getAttribute('data-product-handle');
        if (h) out.push({ h: h, el: el.cloneNode(true) });
      });
    } catch (_) { /* no-op */ }
    return out;
  }

  function fetchTag(tag) {
    var sid = sectionId(), slug = hz(tag);
    if (!sid || !slug) return Promise.resolve([]);
    var qs = new URLSearchParams(location.search);
    qs.delete('page');
    var extra = qs.toString();
    var url = basePath() + '/' + slug + '?section_id=' + encodeURIComponent(sid) + (extra ? '&' + extra : '');
    return fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(itemsFrom)
      .catch(function () { return []; });
  }

  function stripThemeColorTags(bar) {
    if (!bar) return;
    var isColor = window.__isColorTagSlug || function (slug) {
      var set = {};
      document.querySelectorAll(
        '.filter-group--color-remote input[name="filter.p.tag"], [data-link-parent="color"] input[name="filter.p.tag"]'
      ).forEach(function (input) {
        var s = hz(input.value);
        if (s) set[s] = true;
      });
      return set[slug];
    };
    bar.querySelectorAll('.active-filter-tag:not(.js-ccfs-or-chip)').forEach(function (el) {
      if (isColor(hz(el.textContent.trim()))) el.remove();
    });
  }

  function syncBar(tags) {
    var wrap = document.querySelector('.filter-wrapper');
    if (!wrap) return;
    var cnt = wrap.querySelector('.filter-count');
    var bar = wrap.querySelector('.active-filters-inline');
    if (!tags || tags.length < 2) {
      if (bar) bar.querySelectorAll('.js-ccfs-or-chip').forEach(function (n) { n.remove(); });
      if (cnt && cnt.dataset.orBump) { cnt.textContent = cnt.dataset.orBase || '0'; delete cnt.dataset.orBump; }
      if (bar && !bar.querySelector('.active-filter-tag')) bar.remove();
      if (window.__syncColorFilterChips) window.__syncColorFilterChips();
      return;
    }
    if (!bar) { bar = document.createElement('div'); bar.className = 'active-filters-inline'; wrap.appendChild(bar); }
    bar.querySelectorAll('.js-ccfs-or-chip').forEach(function (n) { n.remove(); });
    stripThemeColorTags(bar);
    var clearLink = bar.querySelector('.clear-all-link');
    tags.forEach(function (tag) {
      var a = document.createElement('a');
      a.className = 'active-filter-tag js-ccfs-or-chip';
      a.href = '#';
      a.textContent = tag;
      a.setAttribute('data-ccfs-or-tag', tag);
      if (clearLink) bar.insertBefore(a, clearLink);
      else bar.appendChild(a);
    });
    if (clearLink) bar.appendChild(clearLink);
    else {
      var c = document.createElement('a');
      c.className = 'clear-all-link js-ccfs-or-clear';
      c.href = basePath();
      c.textContent = 'Clear all';
      bar.appendChild(c);
    }
    if (cnt) {
      if (cnt.dataset.orBase == null) cnt.dataset.orBase = cnt.textContent || '0';
      cnt.textContent = String(bar.querySelectorAll('.active-filter-tag:not(.js-ccfs-or-chip)').length + tags.length);
      cnt.dataset.orBump = '1';
    }
    if (window.__syncColorFilterChips) window.__syncColorFilterChips();
  }

  function syncUI(tags) {
    var key = tags && tags.length > 1 ? orKey(tags) : null;
    document.querySelectorAll('[data-ccfs-or="1"]').forEach(function (btn) {
      var on = !!(key && parseBtn(btn).length > 1 && orKey(parseBtn(btn)) === key);
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    syncBar(tags && tags.length > 1 ? tags : null);
  }

  window.__ccfsOrReset = function () {
    window.__ccfsOrActive = null;
    syncBar(null);
    document.querySelectorAll('[data-ccfs-or="1"]').forEach(function (btn) {
      btn.classList.remove('is-active');
      btn.setAttribute('aria-pressed', 'false');
    });
  };

  function syncGridMsg(hasProducts) {
    var section = document.querySelector('[data-section-type="collection"]');
    var grid = document.getElementById('main-collection-product-grid');
    if (!grid) return;
    var loop = grid.querySelector('.product-loop');
    if (loop) {
      loop.hidden = !hasProducts;
      if (hasProducts) loop.removeAttribute('hidden');
    }
    if (hasProducts) {
      var emptyF = grid.querySelector('.js-coll-empty-filter');
      var emptyE = grid.querySelector('.js-coll-empty');
      if (emptyF) emptyF.style.display = 'none';
      if (emptyE) emptyE.style.display = 'none';
      return;
    }
    if (section && window.CollectionFilters && window.CollectionFilters.updateCollectionMsg) {
      window.CollectionFilters.updateCollectionMsg(section);
    }
  }

  function beginOrLoad(loop) {
    var grid = document.getElementById('main-collection-product-grid');
    if (!grid) return;
    var emptyF = grid.querySelector('.js-coll-empty-filter');
    var emptyE = grid.querySelector('.js-coll-empty');
    if (emptyF) emptyF.style.display = 'none';
    if (emptyE) emptyE.style.display = 'none';
    if (!loop) return;
    loop.hidden = false;
    loop.removeAttribute('hidden');
    loop.innerHTML = '';
    loop.style.minHeight = '';
    loop.classList.add('is-ccfs-or-loading');
  }

  function fillLoop(loop, byHandle) {
    var keys = Object.keys(byHandle);
    if (!keys.length) return;
    var mobile = window.matchMedia('(max-width:767px)').matches;
    var cols = mobile ? 2 : 4;
    loop.appendChild(byHandle[keys[0]]);
    var item = loop.querySelector('.product-loop__item');
    var itemH = item ? item.getBoundingClientRect().height : 320;
    var rows = Math.ceil(keys.length / cols);
    var gap = mobile ? 16 : 36;
    loop.innerHTML = '';
    loop.style.minHeight = Math.ceil(rows * itemH + Math.max(0, rows - 1) * gap) + 'px';
    keys.forEach(function (h) { loop.appendChild(byHandle[h]); });
  }

  function paint(tags, pushUrl) {
    var reqKey = orKey(tags);
    var gen = ++loadGen;
    if (window.__clearColorFilterTags) window.__clearColorFilterTags();
    window.__ccfsOrActive = tags.slice();
    syncUI(tags);
    if (pushUrl !== false) history.pushState(null, '', orPath(tags) + location.search);

    var loop = document.querySelector('#main-collection-product-grid .product-loop');
    beginOrLoad(loop);
    var pag = document.querySelector('#main-collection-product-grid > .span-12.auto');
    if (pag) pag.style.display = 'none';

    return Promise.all(tags.map(fetchTag)).then(function (groups) {
      if (gen !== loadGen || !window.__ccfsOrActive || orKey(window.__ccfsOrActive) !== reqKey) return;
      var byHandle = {};
      tags.forEach(function (tag, gi) {
        (groups[gi] || []).forEach(function (it) {
          if (!byHandle[it.h]) byHandle[it.h] = it.el;
        });
      });
      if (loop) {
        loop.classList.remove('is-ccfs-or-loading');
        if (Object.keys(byHandle).length) {
          fillLoop(loop, byHandle);
          requestAnimationFrame(function () { loop.style.minHeight = ''; });
        }
      }
      syncGridMsg(Object.keys(byHandle).length > 0);
    }).catch(function () {
      if (loop) {
        loop.classList.remove('is-ccfs-or-loading');
        loop.style.minHeight = '';
      }
      syncGridMsg(false);
    });
  }

  function clearOr() {
    loadGen++;
    window.__ccfsOrReset();
    if (window.__clearColorFilterTags) window.__clearColorFilterTags();
    var pag = document.querySelector('#main-collection-product-grid > .span-12.auto');
    if (pag) pag.style.display = '';
    history.pushState(null, '', basePath() + location.search);
    if (window.CollectionFilters && window.CollectionFilters.renderPage) {
      window.CollectionFilters.renderPage('', true);
    }
  }

  document.addEventListener('click', function (ev) {
    var chip = ev.target.closest && ev.target.closest('.js-ccfs-or-chip');
    if (chip) {
      ev.preventDefault();
      var tags = (window.__ccfsOrActive || parsePath() || []).filter(function (t) {
        return t !== chip.getAttribute('data-ccfs-or-tag');
      });
      if (tags.length >= 2) paint(tags, true);
      else if (tags.length === 1 && window.__dispatchColorFilterPage) {
        loadGen++;
        window.__dispatchColorFilterPage(tags[0]);
      } else clearOr();
      return;
    }
    if (ev.target.closest && ev.target.closest('.js-ccfs-or-clear')) {
      ev.preventDefault();
      clearOr();
      return;
    }
    var btn = ev.target.closest && ev.target.closest('[data-ccfs-or="1"]');
    if (!btn) return;
    ev.preventDefault();
    ev.stopPropagation();
    var tags = parseBtn(btn);
    if (tags.length < 2) return;
    if (btn.classList.contains('is-active')) { clearOr(); return; }
    paint(tags, true);
  }, true);

  window.__ccfsOrHandlePopstate = function () {
    var tags = parsePath();
    if (tags) {
      paint(tags, false);
      return;
    }
    loadGen++;
    window.__ccfsOrReset();
    var pag = document.querySelector('#main-collection-product-grid > .span-12.auto');
    if (pag) pag.style.display = '';
  };

  function init() {
    var tags = parsePath();
    if (tags) paint(tags, false);
    else syncUI(null);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', function () { syncUI(window.__ccfsOrActive || parsePath()); });
})();
